module.exports = __webpack_public_path__ + "static/media/group-18.c61f5f07.svg";